export const googleMapConstants = {
  DEFAULT_ZOOM_LEVEL: 13.5,
  DEFAULT_SCROLL_WHEEL_SETTING: false,
};
